import { makeStyles } from "@mui/styles";
import theme from "src/theme";

export const useStyles = makeStyles({
    wrapperGameItem: {
        width: "100%",
        height: 66,
        display: "grid",
        gridTemplateColumns: "11fr 16fr 8fr 10fr 45fr 10fr",
        alignItems: "center",
        background: "rgba(245, 245, 245, 0.1)",
        borderRadius: 6,
        [theme.breakpoints.down("lg")]: {
            background: "none",
            justifyContent: "center",
            gridTemplateColumns:
                "minmax(20%, 30%) 30px 20% 40% minmax(56px, 20%)",
            padding: "0px 12px",
            "&:nth-child(even)": {
                backgroundColor: "black",
            },
            "&:nth-child(odd)": {
                backgroundColor: "rgba(245, 245, 245, 0.1)",
            },
        },
        [theme.breakpoints.down("md")]: {
            gridTemplateColumns: "20% 30px 20% 30% minmax(56px, 20%)",
        },
        [theme.breakpoints.down("sm")]: {
            gridTemplateColumns: "16% 30px 20% 37% minmax(56px, 17%)",
        },
    },
    roundsAndType: {
        display: "none",
        [theme.breakpoints.down("lg")]: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            height: "100%",
            gridGap: "0px",
        },
    },
});
